// SVG sprite loader - waits for DOM to be interactive
export default defineNuxtPlugin({
  parallel: true,
  enforce: 'post',

  async setup() {
    if (!process.client)
      return

    // Wait for DOM to be ready before loading non-critical resources
    if (document.readyState !== 'complete' && document.readyState !== 'interactive') {
      await new Promise((resolve) => {
        window.addEventListener('DOMContentLoaded', resolve, { once: true })
      })
    }

    try {
      const config = useRuntimeConfig()
      const path = config.public.environment === 'local' ? '/sprite.svg' : '/public/sprite.svg'

      // Prevent request from hanging indefinitely
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 3000)

      const response = await fetch(path, { signal: controller.signal })
      clearTimeout(timeoutId)

      if (!response.ok) {
        throw new Error(`Failed to load SVG sprite: ${response.status}`)
      }

      const svgText = await response.text()

      const el = document.createElement('div')
      el.classList.add('sprite-container')
      el.innerHTML = svgText
      document.body.appendChild(el)
    }
    catch (error) {
      const { captureException } = await import('@sentry/core')
      captureException(error instanceof Error ? error : new Error('SVG sprite was not loaded'))

      console.error('Failed to load SVG sprite:', error)
    }
  },
})
